/*
 * @Author: Jason
 * @Date: 2025-06-23 11:33:48
 * @LastEditors: Jason
 * @LastEditTime: 2025-06-23 14:54:54
 * @FilePath: /MSFinWeb/src/router/hooks.ts
 * @Description: 路由钩子
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
 */
import router from '@/router';
// 配置常量
const CONFIG = {
    IFRAME_ROUTES: ['/live', '/playback', '/liveplay', '/parameter', '/customMDVR', '/testSDK', '/admin'],
    IFRAME_ROUTE_PREFIXES: ['/liveplay'],
    LOGIN_ROUTES: ['/loginPage', '/login1', '/sso', '/reset-password'],
    DEFAULT_TITLE: 'MS06',
};
// 路由守卫
router.beforeEach((to, from, next) => {
    // 设置页面标题
    document.title = to.meta?.title || localStorage.getItem('web_title') || CONFIG.DEFAULT_TITLE;
    // 检查是否是iframe页面（精确匹配）
    const isExactIframeRoute = CONFIG.IFRAME_ROUTES.includes(to.path);
    // 检查是否是iframe页面（前缀匹配）
    const isPrefixIframeRoute = CONFIG.IFRAME_ROUTE_PREFIXES.some((prefix) => to.path.startsWith(prefix));
    // iframe页面直接通过
    if (isExactIframeRoute || isPrefixIframeRoute) {
        next();
        return;
    }
    // 本地 token
    const token = localStorage.getItem('ms_token');
    // 登录页面逻辑（白名单内的路径直接放行）
    if (CONFIG.LOGIN_ROUTES.includes(to.path)) {
        next();
        return;
    }
    // 未登录重定向
    if (!token) {
        next(CONFIG.LOGIN_ROUTES[0]);
        return;
    }
    // 会话初始化（GetSimpleUser / 本地凭据重登兜底 / 命令权限）已下沉到 Home.vue 的 created，
    // 守卫只做 token 校验后立即放行，避免弱网时把跳转卡在接口响应上。
    next();
});
